import React from 'react';
import Skills from '../Components/Skills';
import { MainLayout} from '../styles/Layouts';
import ServicesSection from '../Components/ServicesSection';
import Title from '../Components/Title';

function ResumePage() {
    return (
        <>
        <title>Skills | Foxicode</title>
        <MainLayout>
            <Title title={'Skills'} span={'スキル'} />
            <Skills />
            <ServicesSection />
        </MainLayout>
        </>
    )
}

export default ResumePage
